<template>

	<v-row class="mt-5 mb-5">

		<v-col offset-lg="4" lg="4" offset-md="3" md="6" offset-sm="2" sm="8">

		  <form @submit.prevent="login()" id="login-form">

	    	<v-card class="pa-4 pb-2" style="background: #101010;" elevation="20">
	    		

	    		<div class="text-center mb-3">
	    			<router-link to="/">
	    				<img src="@/assets/img/logo.png" width="150">
	    			</router-link>
	    		</div>


					<v-text-field
						type="email"
	          label="Correo electrónico"
	          v-model="user.email"          
	          name="email"
	          id="email"
	          filled
	          dark
	          required
	        ></v-text-field> 	


	        <v-text-field
	        	type="password"
	          label="Contraseña"
	          v-model="user.password"
	          name="password"
	          id="password"
	          filled
	          dark
	          required
	          minlength="8"
	          maxlength="20"
	        ></v-text-field>  


	  			<!-- error -> penalizacion -->
	  			<v-alert class="error text-center" style="font-size: 14px !important;" v-if="penalize">
	        	Demasiados intentos fallidos. Vuelve a intentarlo en <b>{{penaltyTime}}</b> segundos.
	      	</v-alert>


	        <v-btn type="submit" x-large block id="login-form-btn">
			      Acceder
			    </v-btn>


			    <p class="mt-5 mb-0" style="color: gray">
			    	<small>¿No tienes cuenta? Registrate <router-link class="auth-link" to="/autenticacion/registrar/">aquí</router-link></small>
			    </p>


			    <p class="mt-2 mb-0">
			    	<small><router-link class="auth-link" to="/autenticacion/recuperar/">¿Olvidaste tu contraseña?</router-link></small>
			    </p>


			    <p class="mt-5 mb-4 text-center">
			    	<small style="color: gray">&copy; 2023 WOW ENVÍOS</small>
			    </p>


	    	</v-card>
							
		  </form>

	  </v-col>

	</v-row>
  
</template>


<script>
	
	import UserService from '@/shared/services/UserService'

	export default 
	{
		
		data() {
			return {
				user: {
					email: null,
					password: null
				},
				penalize: false,
				penaltyTime: 0
			}
		},

		methods: {

			async login()
			{
	    	const resp = await UserService.login(this.user)

	    	if(resp.data.mesg == 'OK')
	    	{
	    		localStorage.setItem('token', resp.data.token)

	    		if(resp.data.rol == 'admin')
	    			this.$router.push('/cms/')
	    		else
	    			this.$router.push('/usuario/')
	    	}

	    	else if(resp.data.mesg == 'PENALIZE') // penalizacion
	  		{
	  			this.penalize = true
	  			this.penaltyTime = resp.data.penalty_time
	  			$('#login-form-btn').prop('disabled', true)

	  			setTimeout(()=> this.desactivePenalize(), 1000)
	  		}

	  		else if(resp.data.mesg == 'ACCOUNT_INACTIVE') // account inactive
	  		{
	  			SwalAlert('', 'Tu cuenta esta inactiva', 'warning')
	  		}

	  		else if(resp.data.mesg == 'ACCOUNT_DELETED') // account deleted
	  		{
	  			SwalAlert('', 'Esta cuenta ha sido eliminada', 'error')
	  		}

				else // error usuario o clave
	  		{
	  			SwalAlert('', 'Correo electrónico o contraseña incorrecta.', 'error')
	  		}

			},


			desactivePenalize()
			{
				--this.penaltyTime
				if(this.penaltyTime == 0)
				{
					this.penalize = false
					$('#login-form-btn').prop('disabled', false)
				}
				else
					setTimeout(()=> this.desactivePenalize(), 1000)
			}

		}

	}

</script>